import { Component, OnInit, ElementRef, ViewChild, ChangeDetectionStrategy, ChangeDetectorRef, HostListener, ViewChildren, Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { merge, BehaviorSubject, fromEvent } from 'rxjs';
import { TokenStorage } from '../../../../../../core/auth/_services';
import { CommonConFig } from '../../../dung-chung/__model/common_config.model';
import { DungChungService } from '../../../dung-chung/__services/dung-chung.service';
import { SubheaderService } from '../../../../../../core/_base/layout';
import { LayoutUtilsService, QueryParamsModel } from '../../../../../../core/_base/crud';
import { FunctionPublic } from '../../../dung-chung/__function/common_function';
import moment from 'moment';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { KDDatHangService } from '../kd-dat-hang-service/kd-dat-hang.service';
import { HistoriesForecastChangeBody } from '../kd-dat-hang-model/kd-dat-hang.model';

@Component({
	selector: 'm-lich-su-thay-doi-forecast',
	templateUrl: './lich-su-thay-doi-forecast.component.html',
	styleUrls: ['./lich-su-thay-doi-forecast.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [DatePipe]
})
export class LichSuThayDoiForecastComponent implements OnInit {
	// Config Form
	CONFIG: CommonConFig;
	isChange: boolean = false;		// Trường kiểm tra dialog có cập nhập - thay đổi dữ liệu hay không
	saveAddedTTHV: number[] = [];
	viewLoading = false;
	historiesForecastChangeData: HistoriesForecastChangeBody[] = [];
	loadingSubject = new BehaviorSubject<boolean>(false);
	loading$ = this.loadingSubject.asObservable();
	//#endregion Khai báo biến

	//#region Constructor
	constructor(
		private _service: KDDatHangService,
		@Inject(MAT_DIALOG_DATA) public data: any,
		public dialog: MatDialog,
		private router: Router,
		private changeDetect: ChangeDetectorRef,
		public dialogRef: MatDialogRef<LichSuThayDoiForecastComponent>,
		private layoutUtilsService: LayoutUtilsService) {
		this.dialogRef.disableClose = true;
	}
	//#endregion Constructor

	//#region Load Data
	ngOnInit() {
		this.CONFIG = new CommonConFig();
		this.dialogRef.keydownEvents().subscribe(event => {
			if (event.key == "Escape") {
				this.back();
			}
		});
		this._service.historiesForecastChange(this.data.forecastId).subscribe(res => {
			if (res && res.status == 1) {
				var result = res.data ? res.data : [];
				this.historiesForecastChangeData = [...result];
				this.changeDetect.detectChanges();
			} else {
				this.layoutUtilsService.showErorr(res.error.message);
			}
		});
	}

	ngAfterViewInit() {
		this.changeDetect.detectChanges();
	}

	menuChange(e: any, type: 0 | 1 = 0) {
		this.layoutUtilsService.menuSelectColumns_On_Off();
	}

	checkDashboardRoute() {
		if (this.router.url === '/')
			return true;
		return false;
	}

	back() {
		this.dialogRef.close({
			isChange: this.isChange,
			dataAdd: this.saveAddedTTHV
		});
	}

	f_number(item: any = "0.00000") {
		return FunctionPublic.F_NUMBER_DYNAMIC(item, FunctionPublic.MAX_POINT);
	}
}
